import { z } from "zod";

const swishSettingsZodObject = z.object({
    _id: z.literal("swish_settings"),
    _type: z.literal("SWISH_SETTINGS"),
    enabled: z.boolean(),
    disabledMessage: z.string(),
});

type SwishSettings = z.infer<typeof swishSettingsZodObject>;

const swishSettingsZodScheme =
    swishSettingsZodObject as z.ZodSchema<SwishSettings>;

export { swishSettingsZodObject, swishSettingsZodScheme };
export type { SwishSettings };
